const patterns = {
  money: /(^0|^[1-9]\d*)(\.\d{0,2})?$/,
  phone: /^1[3456789]\d{9}/,
  discount: /(^0|^[1-9]\d?|^10{2})$/
}

const RegExps = patterns

const rules = {
  phone: [
    {
      pattern: RegExps.phone,
      trigger: 'blur',
      message: '请输入正确11位手机号'
    }
  ],
  money: [
    {
      pattern: RegExps.money,
      trigger: 'blur',
      message: '请输入正确的金额，最多保留两个小数'
    }
  ],
  discount: [
    {
      pattern: RegExps.discount,
      trigger: 'blur',
      message: '请输入正确的折扣，0 - 100之间的整数'
    }
  ]
}

function isType (key, val) {
  const pattern = patterns[key]
  if (!pattern) {
    throw new Error('不支持的验证类型！')
  }
  return patterns[key].test(val)
}

export {
  RegExps
}

export default {
  RegExps,
  rules,
  isMoney: val => isType('money', val),
  isDiscount: val => isType('discount', val)
}



// WEBPACK FOOTER //
// ./src/utils/validator.js